export enum Placement {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
}
